import React from 'react';
import { useTranslate } from '@hooks';
import { affiliateTabs } from '@constants';
import { Nav } from 'reactstrap';
import { TabLink } from '@dotone/react-ui-core';

const AffiliateTabNav = ({ activeTab, onClick, disabled = false, ...otherProps }) => {
  const { t } = useTranslate('affiliate', 'tabs');
  const tabs = Object.values(affiliateTabs).map((tab) => ({
    id: tab,
    name: t(tab),
  }));

  return (
    <Nav pills className="custom-pills font-medium" {...otherProps}>
      {tabs.map((tab) => (
        <TabLink
          key={tab.id}
          active={activeTab === tab.id}
          onClick={() => onClick(tab.id)}
          disabled={disabled}
        >
          {tab.name}
        </TabLink>
      ))}
    </Nav>
  );
};

export default AffiliateTabNav;
